import { render, staticRenderFns } from "./DeleteTemplateSchoolDialog.vue?vue&type=template&id=b7cd3354&scoped=true"
import script from "./DeleteTemplateSchoolDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateSchoolDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateSchoolDialog.vue?vue&type=style&index=0&id=b7cd3354&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cd3354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7cd3354')) {
      api.createRecord('b7cd3354', component.options)
    } else {
      api.reload('b7cd3354', component.options)
    }
    module.hot.accept("./DeleteTemplateSchoolDialog.vue?vue&type=template&id=b7cd3354&scoped=true", function () {
      api.rerender('b7cd3354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/TableSearchDialog/DeleteTemplateSchoolDialog.vue"
export default component.exports